/* eslint-disable no-param-reassign */
import _ from 'lodash';

import {PRESSURE_ROW} from '@/constants/enums';
import {createNewJsonObject} from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import * as PRESSURE_CONSTANT from '../constant/pressureContentConstant';
import * as CONSTANT from '../constant/sequenceContentConstants';
import {GetCycleDefaultValue} from '../data/manualProfileData';

import {ConvertRepeatMode} from './commonFunction';

export const AddSequence = (operations, seqTemplate) => {
  operations = createNewJsonObject(operations);
  const newOrder = GetSequenceId(operations);
  const newSequence = createNewJsonObject(seqTemplate);
  newSequence.Id = newOrder.toString();

  newSequence.TempRepeat = newSequence.Repeat;
  operations.push(newSequence);
  return operations;
};
export const AddSequenceByType = async (operations, seqTemplate, newType) => {
  operations = createNewJsonObject(operations);

  const newOrder = GetSequenceId(operations);
  const newSequence = createNewJsonObject(seqTemplate);

  newSequence.Id = newOrder.toString();
  newSequence.TempRepeat = newSequence.Repeat;

  //   newSequence = await UpdateSequenceType(newSequence, newType);
  //   newSequence = await UpdateTempRate(newSequence, newType);
  //   newSequence = await UpdateDiaphragmPressure(newSequence, newType);

  operations.push(newSequence);
  operations = await ChangeSequenceType(operations.length - 1, newType, operations);
  consoleLog('AddSequenceByType new', operations, newSequence);
  return operations;
};

export const GetSequenceId = (operations) => {
  if (operations.length === 0) return 1;
  return (
    // eslint-disable-next-line prefer-spread
    Math.max.apply(
      Math,
      operations.map((o) => parseInt(o.Id, 10)),
    ) + 1
  );
};

// ------ Change sequence content

// index : index of sequence
// newType : new value of sequence
// operations : All operations for sequence runners
export const ChangeSequenceType = async (index, newType, operations, defaultConfigSetup) => {
  operations = createNewJsonObject(operations);
  operations[index] = UpdateSequenceType(operations[index], newType, defaultConfigSetup);
  operations[index] = await UpdateTempRate(operations[index], newType);
  return operations;
};
// newType : new value of sequence
// operations : All operations for sequence runners
export const UpdateSequenceType = (operation, newType, defaultConfigSetup) => {
  operation.Sequence = newType;
  switch (newType) {
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.PRIME.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingClose;
      operation.SequenceParams.Hi.DiaphragmTimingOpen = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Hi.DiaphragmTimingClose = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingClose;
      break;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingClose;
      operation.SequenceParams.Hi.DiaphragmTimingOpen = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Hi.DiaphragmTimingClose = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingClose;
      break;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.HI;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.MainAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.MainAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Hi.DiaphragmTimingOpen = defaultConfigSetup.MainAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Hi.DiaphragmTimingClose = defaultConfigSetup.MainAdvSetup.DiaphragmTimingClose;
      operation.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.MainAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.MainAdvSetup.DiaphragmTimingClose;
      break;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.DiafiltrationAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.DiafiltrationAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.DiafiltrationAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.DiafiltrationAdvSetup.DiaphragmTimingClose;
      operation.SequenceParams.Hi.DiaphragmTimingOpen = defaultConfigSetup.DiafiltrationAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Hi.DiaphragmTimingClose = defaultConfigSetup.DiafiltrationAdvSetup.DiaphragmTimingClose;
      break;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.REVERSE_CONCENTRATE.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingClose;
      operation.SequenceParams.Hi.DiaphragmTimingOpen = defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingOpen;
      operation.SequenceParams.Hi.DiaphragmTimingClose = defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingClose;
      break;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Lo.DiaphragmTimingOpen =
        defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingOpen.toString();
      operation.SequenceParams.Lo.DiaphragmTimingClose =
        defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingClose.toString();
      operation.SequenceParams.Hi.DiaphragmTimingOpen =
        defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingOpen.toString();
      operation.SequenceParams.Hi.DiaphragmTimingClose =
        defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingClose.toString();
      break;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.HI;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.TubeMixingAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.TubeMixingAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Lo.DiaphragmTimingOpen =
        defaultConfigSetup.TubeMixingAdvSetup.DiaphragmTimingOpen.toString();
      operation.SequenceParams.Lo.DiaphragmTimingClose =
        defaultConfigSetup.TubeMixingAdvSetup.DiaphragmTimingClose.toString();
      operation.SequenceParams.Hi.DiaphragmTimingOpen =
        defaultConfigSetup.TubeMixingAdvSetup.DiaphragmTimingOpen.toString();
      operation.SequenceParams.Hi.DiaphragmTimingClose =
        defaultConfigSetup.TubeMixingAdvSetup.DiaphragmTimingClose.toString();
      break;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE:
      operation.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.HI;
      operation.PressureState.PressureConfig.Hi = defaultConfigSetup.RecirculateAdvSetup.PressureAdvSetup;
      operation.PressureState.PressureConfig.Lo = defaultConfigSetup.RecirculateAdvSetup.PressureAdvSetup;
      operation.SequenceParams.Lo.DiaphragmTimingOpen =
        defaultConfigSetup.RecirculateAdvSetup.DiaphragmTimingOpen.toString();
      operation.SequenceParams.Lo.DiaphragmTimingClose =
        defaultConfigSetup.RecirculateAdvSetup.DiaphragmTimingClose.toString();
      operation.SequenceParams.Hi.DiaphragmTimingOpen =
        defaultConfigSetup.RecirculateAdvSetup.DiaphragmTimingOpen.toString();
      operation.SequenceParams.Hi.DiaphragmTimingClose =
        defaultConfigSetup.RecirculateAdvSetup.DiaphragmTimingClose.toString();
      break;
    default:
      break;
  }

  return operation;
};

// newType : new value of sequence
// operations : All operations for sequence runners
export const UpdateTempRate = async (operation, newType) => {
  const cycleParam = await GetCycleDefaultValue();

  if (newType === CONSTANT.SEQUENCE_TYPE_ALL_ENUM.PRIME.BE) {
    const cycleMinute = cycleParam.PrimeTiming / 60000;
    operation.TempRepeat = cycleMinute.toFixed(2);
  } else if (
    newType === CONSTANT.SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE ||
    newType === CONSTANT.SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE
  ) {
    const cycleMinute = cycleParam.RecoverTiming / 60000;
    operation.TempRepeat = cycleMinute.toFixed(2);
  } else {
    operation.TempRepeat = 0.01;
  }
  if (operation.RepeatType !== CONSTANT.RUN_TIME_MODE.MINUTES.VALUE) {
    operation.RepeatType = CONSTANT.RUN_TIME_MODE.MINUTES.VALUE;
    operation = ConvertRepeatMode(operation);
    operation.RepeatType = CONSTANT.RUN_TIME_MODE.TIMES.VALUE;
  }
  return operation;
};
export const UpdateDiaphragmPressure = async (operation, newType) => {
  await GetCycleDefaultValue();
  if (newType === CONSTANT.SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE) {
    operation.PressureState.PressureConfig[PRESSURE_CONSTANT.PRESSURE_TYPE.LO][PRESSURE_ROW.DIAPHRAGM] =
      CONSTANT.LowDiaphragmPressure.Default;
  } else {
    operation.PressureState.PressureConfig[PRESSURE_CONSTANT.PRESSURE_TYPE.LO][PRESSURE_ROW.DIAPHRAGM] =
      CONSTANT.LowDiaphragmPressure.PreventLeaks;
  }
  return operation;
};

export const ChangeSequenceTempRepeat = (index, newMinutes, operations) => {
  operations = createNewJsonObject(operations);
  operations[index] = UpdateSequenceTempRepeat(operations[index], newMinutes);
  return operations;
};
export const UpdateSequenceTempRepeat = (operation, newMinutes) => {
  operation.TempRepeat = newMinutes;
  return operation;
};

export const ChangeSequenceTotalRepeat = (index, newTotalRepeat, operations) => {
  operations = createNewJsonObject(operations);
  operations[index] = UpdateSequenceTotalRepeat(operations[index], newTotalRepeat);
  return operations;
};

const UpdateSequenceTotalRepeat = (operation, newTotalRepeat) => {
  operation.Repeat = newTotalRepeat;
  return operation;
};

export const ChangeRepeatMode = (index, newRepeatMode, operations) => {
  operations = createNewJsonObject(operations);
  operations[index] = UpdateSequenceRepeatMode(operations[index], newRepeatMode);
  return operations;
};

export const UpdateSequenceRepeatMode = (operation, newRepeatMode) => {
  operation.RepeatType = newRepeatMode;
  return operation;
};

// index : array index
// newState : new value of state
// operations  : array of operatiponns
export const ChangeSequenceState = (index, newState, operations) => {
  operations = createNewJsonObject(operations);
  operations[index] = UpdateSequenceState(operations[index], newState);
  return operations;
};

export const UpdateSequenceState = (operation, newState) => {
  operation.Active = newState;
  return operation;
};

export const DeleteSelectedSequence = (index, operations) => {
  operations = createNewJsonObject(operations);
  operations = DeleteSequence(index, operations);
  return operations;
};

const DeleteSequence = (index, operations) => {
  if (index !== -1) {
    operations.splice(index, 1);
  }
  return operations;
};
export const ChangePressureType = (index, newPressureType, operations) => {
  operations = createNewJsonObject(operations);
  operations[index] = UpdatePressureType(operations[index], newPressureType);
  return operations;
};

export const UpdatePressureType = (operation, newPressureType) => {
  operation.PressureState.PressureType = newPressureType;
  return operation;
};
// ------ End sequence content

export const RepeatModeCheck = (_fullOpeartionsParam) => {
  const fullOpeartionsParam = createNewJsonObject(_fullOpeartionsParam);
  const operations = createNewJsonObject(fullOpeartionsParam.Operations);

  const opearionsLength = operations.length;
  for (let i = 0; i < opearionsLength; i++) {
    const opeartion = operations[i];
    operations[i] = ConvertMinutesToRepeat(opeartion);
  }
  fullOpeartionsParam.Operations = operations;
  return fullOpeartionsParam;
};

const ConvertMinutesToRepeat = (operation) => {
  if (operation.RepeatType === CONSTANT.RUN_TIME_MODE.MINUTES.VALUE) {
    const totalTimeEachSequnce = CalcTimeEachSequence(operation);
    const MINUTE = 60000;
    // save minutes to repeat
    const newRepeatValue = (operation.TempRepeat || operation.Repeat) * (MINUTE / totalTimeEachSequnce).toFixed(0); // operation.TempRepeat
    operation.Repeat = Math.round(newRepeatValue);
  } else {
    const newRepeatValue = operation.TempRepeat || operation.Repeat; // operation.TempRepeat
    operation.Repeat = newRepeatValue;
  }

  return operation;
};

export const CalcTimeEachSequence = (operation) => {
  let DiaphragmTimingOpen = 0;
  let DiaphragmTimingClose = 0;
  let valveTiming = 0;
  if (operation.PressureState.PressureType === PRESSURE_CONSTANT.PRESSURE_TYPE.LO) {
    DiaphragmTimingOpen = operation.SequenceParams.Lo.DiaphragmTimingOpen;
    DiaphragmTimingClose = operation.SequenceParams.Lo.DiaphragmTimingClose;
    valveTiming = operation.SequenceParams.Lo.ValveTiming;
  } else {
    DiaphragmTimingOpen = operation.SequenceParams.Hi.DiaphragmTimingOpen;
    DiaphragmTimingClose = operation.SequenceParams.Hi.DiaphragmTimingClose;
    valveTiming = operation.SequenceParams.Hi.ValveTiming;
  }
  const totalTimeEachSequnce = Number(DiaphragmTimingOpen) + Number(DiaphragmTimingClose) + Number(valveTiming);
  return totalTimeEachSequnce;
};

export const UpdateDiaphragmTiming = (sequence, newValue, type) => {
  sequence.SequenceParams[type].DiaphragmTiming = newValue;
  return sequence;
};

export const UpdateDiaphragmTimingOpen = (sequence, newValue, type) => {
  sequence.SequenceParams[type].DiaphragmTimingOpen = newValue;
  return sequence;
};

export const UpdateDiaphragmTimingClose = (sequence, newValue, type) => {
  sequence.SequenceParams[type].DiaphragmTimingClose = newValue;
  return sequence;
};

export const UpdateValveTiming = (sequence, newValue, type) => {
  sequence.SequenceParams[type].ValveTiming = newValue;
  return sequence;
};
// return \
// True : equals
// False : not equals
/**
 * @deprecated function not use
 * @param {*} sequence
 * @param {*} seqTemplate
 * @returns
 */
export const CompareSequenceWithDefault = (sequence, seqTemplate) => {
  sequence = createNewJsonObject(sequence);
  const defaultConfig = createNewJsonObject(seqTemplate);
  // TODO: ADD MIXING FEATURE F.A.W

  if (sequence.Sequence === CONSTANT.SEQUENCE_TYPE[CONSTANT.SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].value) {
    defaultConfig.TempRepeat = 7;
  } else if (
    sequence.Sequence === CONSTANT.SEQUENCE_TYPE[CONSTANT.SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE].value ||
    sequence.Sequence === CONSTANT.SEQUENCE_TYPE[CONSTANT.SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE].value
  ) {
    defaultConfig.TempRepeat = 3;
  }
  sequence.Id = '-1'; // ignored id
  sequence.Sequence = CONSTANT.SEQUENCE_TYPE[CONSTANT.SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].value;
  sequence.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
  return _.isEqual(defaultConfig, sequence);
};

export const ValidateBottlePressure = (newBottleValue, oldValue, pressureSourceViewValue) => {
  newBottleValue = parseFloat(newBottleValue);
  const pressureTolerance = 3; // add to tolerance bc pressure can't to near with presure source
  const pressureSourceViewValueWithTolerance = parseFloat(pressureSourceViewValue) - pressureTolerance;

  if (newBottleValue >= pressureSourceViewValueWithTolerance) {
    const threshold = pressureSourceViewValueWithTolerance;
    return {
      isValid: false,
      message: `Pressure bottle should be less than pressure source - ${pressureTolerance} psi = ${threshold} psi`,
    };
  }
  return {
    isValid: true,
    message: 'OK BOSS',
  };
};

export const ValidateDiaphragmPressure = (newDiaphragmValue, oldValue, pressureSourceViewValue) => {
  newDiaphragmValue = parseFloat(newDiaphragmValue);
  const pressureTolerance = 3; // add to tolerance bc pressure can't to near with presure source
  const pressureSourceViewValueWithTolerance = parseFloat(pressureSourceViewValue) - pressureTolerance;

  if (newDiaphragmValue >= pressureSourceViewValueWithTolerance) {
    const threshold = pressureSourceViewValueWithTolerance;
    return {
      isValid: false,
      message: `Pressure diaphragm should be less than pressure source - ${pressureTolerance} psi = ${threshold} psi`,
    };
  }
  return {
    isValid: true,
    message: 'OK BOSS',
  };
};

export const ValidateSourcePressure = (
  newSourceValue,
  oldValue,
  pressureBottleViewValue,
  pressureDiaphragmViewValue,
  jmlPressure,
) => {
  const pressureTolerance = 3;
  newSourceValue = parseFloat(newSourceValue);
  pressureBottleViewValue = parseFloat(pressureBottleViewValue) + pressureTolerance;
  pressureDiaphragmViewValue = parseFloat(pressureDiaphragmViewValue) + pressureTolerance;
  if (newSourceValue <= pressureBottleViewValue) {
    const threshold = pressureBottleViewValue;
    return {
      isValid: false,
      message: `Pressure source should be more than pressure bottle + ${pressureTolerance} psi = ${threshold} psi `,
    };
  }
  if ((jmlPressure === 4) & (newSourceValue <= pressureDiaphragmViewValue)) {
    const threshold = pressureDiaphragmViewValue;
    return {
      isValid: false,
      message: `Pressure source should be more than pressure diaphragm + ${pressureTolerance} psi = ${threshold} psi `,
    };
  }
  return {
    isValid: true,
    message: 'OK BOSS',
  };
};
